import {
    SET_EXPANDED,
    SET_INDEX,
    SET_SHOW_DETAILS,
} from './RetirementIncomeChartActions';

const
    INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    const {
        type,
    } = action;

    switch (type) {
        case SET_EXPANDED:
            return {
                ...state,
                [action.clientId]: {
                    ...(state[action.clientId] || {}),
                    expanded: action.expanded,
                },
            };
        case SET_INDEX:
            return {
                ...state,
                [action.clientId]: {
                    ...(state[action.clientId] || {}),
                    index: action.index,
                },
            };
        case SET_SHOW_DETAILS:
            return {
                ...state,
                [action.clientId]: {
                    ...(state[action.clientId] || {}),
                    showDetails: action.showDetails,
                },
            };
        default:
            return state;
    };
};
